// NO EDITAR A MANO
// const id = "footer.link_social.url-linkedin";
const valor = `https://www.linkedin.com/company/meteored/`;

export default valor;
